import {ColumnDef, ColumnHelper, createColumnHelper} from "@tanstack/react-table";
import moment from "moment";
import {formatAmountToString} from "../../utils/helpers/logicHelper";

const column: ColumnHelper<IOrganisationAdvancedPaymentEntries> = createColumnHelper<IOrganisationAdvancedPaymentEntries>()

export const AdvancedPaymentEntriesColumns: ColumnDef<IOrganisationAdvancedPaymentEntries, string>[] = [
  column.accessor('date', {
    header: () => <span>DATE</span>,
    cell: info => <span>{moment(info.getValue()).format('LL')}</span>,
    footer: info => info.column.id,
  }),
  column.accessor('invoice_ref', {
    header: () => <span>INVOICE REF</span>,
    cell: info => info.getValue(),
    footer: info => info.column.id,
  }),
  column.accessor('amount', {
    header: () => <span>Amount</span>,
    cell: info => <span>{formatAmountToString(info.getValue())}</span>,
    footer: info => info.column.id,
  }),
  column.accessor('type', {
    header: () => <span>TYPE</span>,
    cell: info => info.getValue(),
    footer: info => info.column.id,
  }),
  column.accessor('description', {
    header: () => <span>DESCRIPTION</span>,
    cell: info => info.getValue(),
    footer: info => info.column.id,
  }),
  column.accessor('status', {
    header: () => <span>Status</span>,
    cell: info => info.getValue(),
    footer: info => info.column.id,
  })
];
